export const ActualizarEqOtIni=(setEquiposOtIni,equipoActualizado)=>{
    setEquiposOtIni(prevEquipos =>
        prevEquipos.map(equipo => equipo._id === equipoActualizado._id ? equipoActualizado : equipo)
    );
} 